<p-card class="mt-10" [header]="title">
    <ng-template #content>
        <div class="py-3">
            The page could not be found. You may have clicked on an incorrect link or mistyped the
            URL. It is also possible that we have renamed, moved or deleted the content.
        </div>
    </ng-template>
    <ng-template #footer>
        <p-button label="Back" routerLink="." (onClick)="goBack()"></p-button>
    </ng-template>
</p-card>
